var youtube = new function () {
    this.apiLoaded = false;
    this.player = false;

    this.doLoad = function () {
        if (!this.apiLoaded) {
            var tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/player_api';
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    };
    this.doReplacement = function ($element) {
        const img = $element.find('img'),
            videoId = youtube.getId($element.attr('href'));
        $element.addClass('you-tube-playing');
        img.after('<div id="youtube-player-' + videoId + '"></div>');
        this.player = new YT.Player('youtube-player-' + videoId, {
            width: img.outerWidth(),
            height: img.outerHeight(),
            videoId: videoId,
            playerVars: {
                autoplay: true,
                modestbranding: true,
                controls: false
            }
        });
    };
    this.doModal = function ($element) {
        $('#youtube-modal').data('videoId', youtube.getId($element.attr('href')));
        (data.cssLoadedFully.indexOf(assets.alert) > 0)
            ? this.showModal(null, null)
            : data.doAddCss(assets.alert, 'youtube:showModal');
    };

    this.showModal = function(event, el) {
        this.player = new YT.Player('youtube-model-video', {
            videoId: $('#youtube-modal').data('videoId'),
            playerVars: {
                autoplay: true,
                modestbranding: true,
                controls: true
            }
        });
        $('body').addClass('has-alerts');
        $('#youtube-modal').css({display: '', height: '', padding: ''});
    }

    this.getId = function(url) {
        var id = '';
        url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if (url[2] !== undefined) {
            id = url[2].split(/[^0-9a-z_\-]/i);
            id = id[0];
        }
        else {
            id = url;
        }
        return id;
    }
};

$(function() {
    youtube.doLoad();
    $(document).on('click', '[data-youtube-replace]', function (e) {
        e.preventDefault();
        $(this).closest('.slick-slider').length
            ? youtube.doModal($(this))
            : youtube.doReplacement($(this));
    });
});